var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14998 18.575L10.575 10.175C10.675 10.075 10.7456 9.96667 10.787 9.85C10.829 9.73333 10.85 9.60833 10.85 9.475C10.85 9.34167 10.829 9.21667 10.787 9.1C10.7456 8.98333 10.675 8.875 10.575 8.775L2.14998 0.35C1.91664 0.116667 1.62498 0 1.27498 0C0.924976 0 0.624976 0.125 0.374976 0.375C0.124976 0.625 -2.38419e-05 0.916667 -2.38419e-05 1.25C-2.38419e-05 1.58333 0.124976 1.875 0.374976 2.125L7.72498 9.475L0.374976 16.825C0.141643 17.0583 0.0249758 17.3457 0.0249758 17.687C0.0249758 18.029 0.149976 18.325 0.399976 18.575C0.649976 18.825 0.941642 18.95 1.27498 18.95C1.60831 18.95 1.89998 18.825 2.14998 18.575V18.575Z",
    fill: "#999999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowLeft.2432fab6b97795e6658890db6ea65210.svg";